import { render, staticRenderFns } from "./CamerataUserExamine.vue?vue&type=template&id=0964c46e"
import script from "./CamerataUserExamine.vue?vue&type=script&lang=js"
export * from "./CamerataUserExamine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports